import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import ReopenJobDescriptionFromExternalWebsiteForm from './ReopenJobDescriptionFromExternalWebsiteForm';

import { useJobDescriptionsFromExternalWebsitesState, useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';

const ReopenJobDescriptionFromExternalWebsiteModal = () => {
  const jobDescriptionsFromExternalWebsitesState = useJobDescriptionsFromExternalWebsitesState();
  const { closeReopenJobDescriptionFromExternalWebsiteModal } = useJobDescriptionsFromExternalWebsitesActions();

  return (
    <StandardModal
      isOpen={jobDescriptionsFromExternalWebsitesState?.reopenJobDescriptionFromExternalWebsiteModalIsOpen}
      contentLabel={'Reopen Job Description from External Website'}
      onRequestClose={() => {
        closeReopenJobDescriptionFromExternalWebsiteModal();
      }}
    >
      <ReopenJobDescriptionFromExternalWebsiteForm />
    </StandardModal>
  );
};

export default ReopenJobDescriptionFromExternalWebsiteModal;
